import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSeenCheckmarkLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.3167 6.38621C17.5608 6.6303 17.5607 7.02603 17.3166 7.27009L11.0892 13.4968C10.6922 13.8952 10.0484 13.894 9.65221 13.4978L8.41961 12.2653L7.18647 13.4983C6.7896 13.8953 6.14738 13.8953 5.75051 13.4983L3.09968 10.8475C2.85561 10.6034 2.85561 10.2078 3.09968 9.96367C3.34376 9.71959 3.73949 9.71959 3.98357 9.96367L6.46849 12.4486L7.5357 11.3814L6.67634 10.522C6.43227 10.2779 6.43227 9.88218 6.67634 9.63809C6.92043 9.39401 7.31615 9.39401 7.56023 9.63809L10.3702 12.4481L16.4328 6.38616C16.6769 6.14209 17.0726 6.14212 17.3167 6.38621ZM13.4148 6.38619C13.6589 6.63026 13.6589 7.02599 13.4148 7.27007L10.8129 9.87185C10.5689 10.1159 10.1732 10.1159 9.92912 9.87185C9.68503 9.62785 9.68503 9.2321 9.92912 8.98801L12.5309 6.38619C12.775 6.1421 13.1707 6.1421 13.4148 6.38619Z",
		fill: "currentColor"
	})
});
export default SvgSeenCheckmarkLine;
